<div class="hello-band py-4 mb-3"  [style.backgroundColor]="''+chapter['backgroundColor']+''">
	<div class="container">
		<div class="row">
			 <div class="col-12 pt-1">
				<h1 class="entry-title">{{chapter['sectionName']}} / {{name}}</h1>
			</div>
		</div>
	</div>
</div>
<div class="container pt-3" *ngIf="lessons">
	<div class="row">
		<ng-container *ngFor="let lesson of lessons">
			<div class="mb-4 col-md-6"  [ngClass]="{
				'col-xl-4': chapter['style'] == '3_COLUMN',
				'col-xl-6': chapter['style'] != '3_COLUMN'
			}">
				<div class="card">
					<img src="{{lesson['image']}}" class="card-img-top" alt="{{lesson['name']}}" />
					<div class="card-body p-5">
						<h3 class="card-title" style="font-size: 150%;">{{lesson['name']}}</h3>
						<p class="card-text" [innerHTML]="text(lesson['description'])"></p>
					</div>
					<div class="mt-auto m-5">
						<a href="/les/{{lesson['id']}}" class="btn btn-card stretched-link px-3" title="Ga naar deze les">
							Ga naar deze les <i class="fas fa-caret-right"></i>
						</a>
					</div>
				</div>
			</div>
		</ng-container>
	</div>
</div>
<div class="container pt-3" *ngIf="choiceAssignments.length > 0">
	<div class="row">
		<div class="col-12 pb-3"><h2>{{choiceAssignmentTitle}}</h2></div>
	</div>
	<div class="row">
		<ng-container *ngFor="let lesson of choiceAssignments">
			<div class="mb-4 col-md-6"  [ngClass]="{
				'col-xl-4': chapter['style'] == '3_COLUMN',
				'col-xl-6': chapter['style'] != '3_COLUMN'
			}">
				<div class="card">
					<img src="{{lesson['image']}}" class="card-img-top" alt="{{lesson['name']}}" />
					<div class="card-body p-5">
						<h3 class="card-title" style="font-size: 150%;">{{lesson['name']}}</h3>
						<p class="card-text" [innerHTML]="text(lesson['description'])"></p>
					</div>
					<div class="mt-auto m-5">
						<a href="/les/{{lesson['id']}}" class="btn btn-card stretched-link px-3" title="Ga naar deze les">
							Ga naar deze les <i class="fas fa-caret-right"></i>
						</a>
					</div>
				</div>
			</div>
		</ng-container>
	</div>
</div>
